import React from "react";
import { connect } from 'react-redux';

import ComponentWrapper from "../../common/ComponentWrapper";
import DashboardAiPage from "./DashboardAiPage";
import DashboardPage from "./DashboardPage";
import BounceLoader from "../../common/BounceLoader";

import { updateJelsSimple } from "../../reducer/jelsReducer";
import { getUrlParameter, removeUrlParameter } from "../../utils";
import SalesIQChatVidget from "../../common/ChatWidget";

import TooltipMarker from "./components/TooltipMarker";
import { TooltipProvider } from "./components/TooltipContext";

class DashboardWrapper extends ComponentWrapper {
  state = {
    node: null,
    timeout: '',
    lastMsgTime: '',
    gmailECMEmail: '',
    milkyUserEmail: '',
    verificationEmail: '',
    sylectusAuthEmail: '',
    loadedAiSetup: false,
    parsingStarted: false,
    isInitialLoading: true,
    showUserConfirm: false,
    hiddenInstructionTooltips: [],
    gmailECMEmailAuthorized: false,
    parsingWasStartedInitially: false,
  };

  componentDidMount = () => {
    this.getUserData();
    this.props.updateJelsSimple();

    if (localStorage.getItem('355')) this.setState({ hiddenInstructionTooltips: [ '355' ] })

    const cChannelId = +getUrlParameter('gmail_auth_sid');
    if (cChannelId) {
      this.getCChannelConnectedEmails(cChannelId);
    }
  };

  // getImports = () => {
  //   this.get({
  //     url: '/meta_query?meta_query=["imports"]',
  //     cb: (res) => {
  //       if (res) {
  //         const { imports } = res._meta_query;
  //         const foundImport15 = imports.find(item => Object.keys(item)[0] === '15');
  //         const foundImport6 = imports.find(item => Object.keys(item)[0] === '6');
  
  //         const importPromises = [];
  //         if (!foundImport15) importPromises.push(this.importApp(15));
  //         if (!foundImport6) importPromises.push(this.importApp(6));

  //         Promise.all(importPromises)
  //           .then(() => {
  //             this.getUserData();
  //           })
  //           .catch((error) => {
  //             console.error("Error importing apps:", error);
  //           });
  //       }
  //     },
  //     disableNotify: true,
  //   });
  // };  

  // importApp = (importAppId) => {
  //   if (this.props.setup.id === importAppId) return;
    
  //   this.postWithData({
  //     url: '/rest/import_app',
  //     data: {
  //       id: importAppId,
  //     },
  //     cb: (data) => {
  //       if (data._status === 'error') console.log(data);
  //     }
  //   });
  // };

  isSylectusMessVisible = () => {
    const sylectusVerificationMessBlock = document.getElementById('#sylectus_auth_message');
    if (sylectusVerificationMessBlock) return true;
    return false
  };

  getCChannelConnectedEmails = (cChannelId) => {
    const { setup } = this.props;

    const reqData = {
      nesting: 3,
      api_key: setup.id,
      filter: {
        nodes: [cChannelId],
      },
    };

    reqData.show_pids = [1300,"1300.2134","1300.2142"];

    this.postWithData({
      url: `/pnkqry3`,
      data: reqData,
      cb: (res) => {
        if (res && res._status === 'ok' && res.trpls && res.trpls[cChannelId]) {
          const emailECMNode = res.trpls[cChannelId][1300][0].oid;
          const gmailECMEmail = res.trpls[emailECMNode] && res.trpls[emailECMNode][2134] && res.trpls[emailECMNode][2134][0].val;
          const gmailECMEmailAuthorized = res.trpls[emailECMNode] && res.trpls[emailECMNode][2142][0].val ? true : false;

          this.setState({ gmailECMEmail, gmailECMEmailAuthorized });
        }
      },
    });
  };

  getUserData = (onboardingWindowOpened, cb) => {
    const { setup } = this.props;
    const { isInitialLoading, parsingWasStartedInitially } = this.state;

    const data = {
      api_key: setup.id,
      filter: {
        ancestor: 18756601, // rfq ecm - concept of email communication method of 15 ontology
      },
      sorter: {
        sort_pid: '',
        sort_by: '',
      },
    };

    this.postWithData({
      url: '/pnkqry3',
      data,
      cb: (res) => {
        if (res._status === 'ok') {
          if (res.trpls && Object.values(res.trpls)[0]) {
            const milkyUserEmail = Object.values(res.trpls)[0][1304] ? Object.values(res.trpls)[0][1304][0].val : '';
            let parsingStarted = Object.values(res.trpls)[0][1626] ? Object.values(res.trpls)[0][1626][0].val : false;
            const verificationEmail = Object.values(res.trpls)[0][1625] ? Object.values(res.trpls)[0][1625][0].val : '';
            const verificationEmailCreationTime = Object.values(res.trpls)[0][1625] ? Object.values(res.trpls)[0][1625][0].upd_time : '';
            const sylectusAuthEmailCreationTime = Object.values(res.trpls)[0][2034] ? Object.values(res.trpls)[0][2034][0].upd_time : '';
            const node = res.query && res.query.length ? res.query[0] : null;
            const sylectusAuthEmail = Object.values(res.trpls)[0][2034] ? Object.values(res.trpls)[0][2034][0].val : '';
            const gmailECMEmail = Object.values(res.trpls)[0][2134] ? Object.values(res.trpls)[0][2134][0].val : '';
            const gmailECMEmailAuthorized = Object.values(res.trpls)[0][2142] ? Object.values(res.trpls)[0][2142][0].val : false;
            const lastMsgTime = Object.values(res.trpls)[0][1915] ? Object.values(res.trpls)[0][1915][0].val : '';

            let hasGmailAuthMethodBtn = false;
            if (res.nodes[node].box && res.nodes[node].box.a && res.nodes[node].box.a.includes(79728448)) { //concept 79728448 is gmail ecm of 15 ontology
              const isRstOfGmailAuthPersist = res.nodes[79728448] && res.nodes[79728448].box.r[79728448].find(rst => +rst.id === 2140);
              if (isRstOfGmailAuthPersist) hasGmailAuthMethodBtn = true;
            }

            if (!parsingStarted) this.parsingNotStartedTimeout(); //|| (!sylectusAuthEmail && this.isSylectusMessVisible())
            else if (parsingStarted && !isInitialLoading && !onboardingWindowOpened) this.props.updateJelsSimple(); // check if still needed

            this.setState({
              node,
              lastMsgTime,
              gmailECMEmail,
              milkyUserEmail,
              parsingStarted,
              verificationEmail,
              sylectusAuthEmail,
              loadedAiSetup: true,
              hasGmailAuthMethodBtn,
              gmailECMEmailAuthorized,
              verificationEmailCreationTime,
              sylectusAuthEmailCreationTime,
              parsingWasStartedInitially: parsingStarted ? true : false,
              showUserConfirm: (!isInitialLoading && parsingStarted && !parsingWasStartedInitially) ? true : false,
              isInitialLoading: false,
            });
          } else {
            this.setState({
              loadedAiSetup: true,
              isInitialLoading: false,
            });
            console.log(res)
          }
        } else {
          this.setState({
            loadedAiSetup: true,
            isInitialLoading: false,
          });
          console.log(res)
        }

        if (cb) cb();
      }
    });
  };

  pluginAuthorization = () => {
    const { node } = this.state;

    this.get({
      url: `/meta_query?meta_query=["google_oauth2"]`,
      cb: (res) => {
        const { client_id, auth_callback, scopes } = res._meta_query.google_oauth2;
        // console.log('client_id:', client_id,'   ', 'auth_callback:', auth_callback, '    ', 'scopes:', scopes);
        // console.log('node:', node);

        const params = new URLSearchParams({
          client_id: client_id,
          redirect_uri: auth_callback,
          response_type: "code",
          scope: scopes,
          access_type: "offline",  /*to get a refresh token*/
          prompt: "consent",  /*forces the user to manually confirm access*/
          state: node, // communication channel node
        });

        const authUrl = `https://accounts.google.com/o/oauth2/auth?${params.toString()}`;

        //console.log('authUrl:', authUrl);

        window.open(
          authUrl,
          '_blank'
        );
      },
    });
  };

  hideUserConfirmation = () => {
    this.setState({ showUserConfirm: false });
  };

  parsingNotStartedTimeout = () => {
    const { timeout } = this.state;
    
    clearTimeout(timeout);
    const newTimeout = setTimeout(() => {
      if (!document.hidden) this.getUserData();
    }, 10000);
    this.setState({ timeout: newTimeout, loadedAiSetup: true });
  };

  hideTooltipMarker = (targetKey) => {
    localStorage.setItem(targetKey, true);
    this.setState({ hiddenInstructionTooltips: [ ...this.state.hiddenInstructionTooltips, targetKey ]});
  };

  render() {
    const { account, setup, updateJelsSimple } = this.props;
    const { timeout, milkyUserEmail, showUserConfirm, verificationEmail, sylectusAuthEmail, hiddenInstructionTooltips,
      verificationEmailCreationTime, sylectusAuthEmailCreationTime, hasGmailAuthMethodBtn, parsingStarted, gmailECMEmailAuthorized,
      gmailECMEmail, loadedAiSetup, lastMsgTime, node } = this.state; //hasGmailAuthMethodBtn

    const userRegistrationEmailAddress = account && account.login;

    return (
      <div>
      <TooltipProvider>
        {(window.location.host === 'mlkwb.ai' || (account && account.is_ai)) ?
          <React.Fragment>
            {loadedAiSetup ?
              <React.Fragment>

                {hiddenInstructionTooltips.includes('355') || parsingStarted ? null :
                  <TooltipMarker targetKey="355" message="Create drivers and update their ZIP codes here" placement="right" onClose={this.hideTooltipMarker} />
                }

                <DashboardAiPage
                  node={node}
                  setup={setup}
                  timeout={timeout}
                  lastMsgTime={lastMsgTime}
                  getUserData={this.getUserData}
                  gmailECMEmail={gmailECMEmail}
                  parsingStarted={parsingStarted}
                  showUserConfirm={showUserConfirm}
                  milkyUserEmail={milkyUserEmail}
                  updateJelsSimple={updateJelsSimple}
                  getUserAiDataUpdate={this.getUserData}
                  sylectusAuthEmail={sylectusAuthEmail}
                  verificationEmail={verificationEmail}
                  gmailECMEmailAuthorized={gmailECMEmailAuthorized}
                  runGmailAuthBtn={hasGmailAuthMethodBtn ? this.pluginAuthorization : null}
                  isSylectusMessVisible={this.isSylectusMessVisible}
                  parsingNotStartedTimeout={this.parsingNotStartedTimeout}
                  sylectusAuthEmailCreationTime={sylectusAuthEmailCreationTime}
                  verificationEmailCreationTime={verificationEmailCreationTime}
                  hideUserConfirmation={this.hideUserConfirmation}
                  userRegistrationEmailAddress={userRegistrationEmailAddress}
                />

                <DashboardPage isAi={true}/>
              </React.Fragment>

            : <BounceLoader/>}
          </React.Fragment>

        : <DashboardPage/>}

        {(window.location.host === 'mlkwb.ai' || (account && account.is_ai)) ?
          <SalesIQChatVidget
            email={milkyUserEmail}
          />
        : null}
        </TooltipProvider>
      </div>
    )
  }
};

export default connect((state) => ({ setup: state.meta.setup, account: state.meta.account }), {
  updateJelsSimple,
})((DashboardWrapper));
